import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from '../../lib/cn';
import styles from './Table.module.css';

export function TableScroll({ children, className, dataTestId }: { children: ReactNode; className?: string; dataTestId?: string }) {
  return <div data-testid={dataTestId} className={cn(styles.scroll, className)}>{children}</div>;
}

export function Table({ children, className, dataTestId }: { children: ReactNode; className?: string; dataTestId?: string }) {
  return (
    <table data-testid={dataTestId} className={cn(styles.table, className)}>
      {children}
    </table>
  );
}

export function THead({ children, dataTestId }: { children: ReactNode; dataTestId?: string }) {
  return <thead data-testid={dataTestId} className={styles.thead}>{children}</thead>;
}

export function TBody({ children, dataTestId }: { children: ReactNode; dataTestId?: string }) {
  return <tbody data-testid={dataTestId}>{children}</tbody>;
}

export function Tr({ className, ...rest }: ComponentPropsWithoutRef<'tr'>) {
  return <tr className={className} {...rest} />;
}

export function Th({ children, className, dataTestId }: { children: ReactNode; className?: string; dataTestId?: string }) {
  return <th data-testid={dataTestId} className={cn(styles.th, className)} scope="col">
    {children}
  </th>;
}

export function Td({
  children,
  className,
  colSpan,
  dataTestId
}: {
  children: ReactNode;
  className?: string;
  colSpan?: number;
  dataTestId?: string;
}) {
  return (
    <td data-testid={dataTestId} className={cn(styles.td, className)} colSpan={colSpan}>
      {children}
    </td>
  );
}
